import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateTaxonomyOutput, TemplateTaxonomyUpdateInput, StepComponents} from 'src/app/models/tool.model';
import { ToastService, ToolService } from '../../services';
import { Execution, Cell } from '../../models';


export interface AddSetModalValue {
  currencyValue: string;
  recoveryRateValue: string;
}

@Component({
    selector: 'app-manage-taxonomies-modal',
    templateUrl: './manage-taxonomies-modal.component.html',
    styleUrls: ['./manage-taxonomies-modal.component.scss'],
    standalone: false
})
export class ManageTaxonomiesModalComponent implements OnInit {

	templateName: string;
	templateTaxonomyInfo: TemplateTaxonomyOutput;
	execution: Execution;
	submit = false;
	loader = false;
	keys: string[];
	selectedKey: string;
	keysLoaded: Promise<boolean>;
	activeIndexTab: number;
	section: StepComponents;
	isTaxonomyChanged: boolean = false;

	@ViewChild('modalBody') modalBody: ElementRef;


  @Output() closeModal: EventEmitter<{ templateTaxonomies: TemplateTaxonomyOutput, activeModal: NgbActiveModal, isTaxonomyChanged: boolean}> = new EventEmitter();

    constructor(
			private toolService: ToolService,
      private activeModal: NgbActiveModal,
      private toastService: ToastService
  ) { }

	async ngOnInit() {
		try {     
			this.loader = true;
			if (this.templateTaxonomyInfo === undefined) {     
				await this.toolService.getTemplateTaxonomy(this.execution.id).subscribe(k => {
					this.templateTaxonomyInfo = k;
					this.keys = Object.keys(this.templateTaxonomyInfo.file_categories_tab);
					this.selectedKey = this.keys[0];
					this.activeIndexTab = 0;
					this.keysLoaded = Promise.resolve(true);
				});
			}
			else {
				this.keys = Object.keys(this.templateTaxonomyInfo.file_categories_tab);
				this.selectedKey = this.keys[0];
				this.activeIndexTab = 0;
				this.keysLoaded = Promise.resolve(true);
			}
			this.loader = false;       
		} catch (error) {
			this.loader = false;
			this.toastService.showError(error.error);
			console.error('error =>', error);
		}
	}

	setTaxonomyChanged($event: boolean) {
		this.isTaxonomyChanged = $event;
	}

	getSelected(selected: string, index: number) {
		this.selectedKey = selected;
		this.activeIndexTab = index;
		this.modalBody.nativeElement.scrollTop();
	}

	getCell(value: string): Cell {
		let cell: Cell = { cell_type:"cella_edit_manuale", value: value };
		return cell;
	}


/**
 * Call the api to save the options selected for Template Taxonomies (ESG)
 * { templateTaxonomies: templateTaxonomyUpdateInput.template_configuration, activeModal: this.activeModal }
 */

	async onSave() {
		this.submit = true;
		const templateTaxonomyUpdateInput: TemplateTaxonomyUpdateInput = {id_execution: this.execution.id, template_configuration: this.templateTaxonomyInfo};
		try {
			await this.toolService.updateTemplateTaxonomy({
				id_execution: templateTaxonomyUpdateInput.id_execution,
				template_configuration: templateTaxonomyUpdateInput.template_configuration
			});
			this.closeModal.emit({ templateTaxonomies: templateTaxonomyUpdateInput.template_configuration, activeModal: this.activeModal, isTaxonomyChanged: this.isTaxonomyChanged});
			this.activeModal.dismiss();
		} catch (error) {
			this.toastService.showError(error.error);
			console.error('error =>', error);
		}
	}
}